import React from 'react'
import { FormattedMessage } from 'react-intl'
import { ListTable } from 'gnos-tables'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../../../constants'

import CustomDate from '../../../../../../../../../../../../../components/CustomDate'
import Link from '../../../../../../../../../../../../../components/TableCell/components/Link'

import './style.scss'

export default function ({ id, intl, documents }) {
    if (_.isEmpty(documents)) return null

    return (
        <div className={'verification-documents-wrapper'}>
            <div className={'info-row'}>
                <FormattedMessage id={`${LOCALE_PREFIX}.endUsersMoreInfoMsg`} />
            </div>
            <div className={'table-wrap'}>
                <ListTable
                    id={`persons-verification-documents-${id}`}
                    columnsDefinition={{
                        title: {
                            width: 250,
                            Cell: (title) => (
                                <span className={cx(title.isNested && 'historic')}>
                                    <FormattedMessage id={`${LOCALE_PREFIX}.documents`} />
                                </span>
                            ),
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'documentUrl',
                                    Cell: (documentUrl) => (
                                        <Link
                                            label={intl.formatMessage({ id: `${LOCALE_PREFIX}.document` })}
                                            iconType={'external'}
                                            openOnNewTab
                                            showIcon
                                            url={documentUrl.value}
                                        />
                                    ),
                                },
                                {
                                    width: 150,
                                    accessor: 'startDate',
                                    Cell: (startDate) =>
                                        startDate.value?.value && (
                                            <span>
                                                <FormattedMessage id={'global.date.from'} />
                                                <CustomDate
                                                    customStyle={{ paddingLeft: '4px' }}
                                                    date={startDate.value?.value}
                                                    precision={startDate.value?.precision}
                                                />
                                            </span>
                                        ),
                                },
                                {
                                    width: 150,
                                    accessor: 'endDate',
                                    Cell: (endDate) =>
                                        endDate.value?.value && (
                                            <span>
                                                <FormattedMessage id={'global.date.to'} />
                                                <CustomDate
                                                    customStyle={{ paddingLeft: '4px' }}
                                                    date={endDate?.value?.value}
                                                    precision={endDate?.value?.precision}
                                                />
                                            </span>
                                        ),
                                },
                            ],
                        },
                        nested: {
                            visibleRows: (value) => {
                                if (_.get(value, 'tables[0].nested', false)) {
                                    // If the first table is nested/historical
                                    const tablesRowsLength = _.get(value, 'tables[0].rows', []).length

                                    if (tablesRowsLength > 10) return 10 // Only show 10 rows on first step

                                    return tablesRowsLength // If there is less than 10 rows, show all rows
                                }

                                return 0 // Hide table if there is multiple tables and the first one isn't historical
                            },
                            // eslint-disable-next-line no-confusing-arrow
                            expandText: (value) =>
                                !_.get(value, 'tables[0].nested', false)
                                    ? intl.formatMessage({ id: `${LOCALE_PREFIX}.historicDocuments` })
                                    : intl.formatMessage({ id: 'global.controlExpand' }),
                            columns: [
                                {
                                    accessor: 'documentUrl',
                                    Cell: (documentUrl) => (
                                        <Link
                                            label={intl.formatMessage({ id: `${LOCALE_PREFIX}.document` })}
                                            iconType={'external'}
                                            openOnNewTab
                                            showIcon
                                            url={documentUrl?.value}
                                        />
                                    ),
                                },
                                {
                                    width: 150,
                                    accessor: 'startDate',
                                    Cell: (startDate) =>
                                        startDate.value?.value && (
                                            <span className={'historic'}>
                                                <FormattedMessage id={'global.date.from'} />
                                                <CustomDate
                                                    customStyle={{ paddingLeft: '4px' }}
                                                    date={startDate?.value?.value}
                                                    precision={startDate?.value?.precision}
                                                />
                                            </span>
                                        ),
                                },
                                {
                                    width: 150,
                                    accessor: 'endDate',
                                    Cell: (endDate) =>
                                        endDate.value?.value && (
                                            <span className={'historic'}>
                                                <FormattedMessage id={'global.date.to'} />
                                                <CustomDate
                                                    customStyle={{ paddingLeft: '4px' }}
                                                    date={endDate?.value?.value}
                                                    precision={endDate?.value?.precision}
                                                />
                                            </span>
                                        ),
                                },
                            ],
                        },
                    }}
                    staticData={{
                        _table: [
                            {
                                key: 'verificationDocuments',
                                tables: [
                                    {
                                        nested: false,
                                        historical: false,
                                        rows: documents.filter((doc) => !doc.inactive),
                                    },
                                    {
                                        nested: true,
                                        historical: true,
                                        rows: documents.filter((doc) => doc.inactive),
                                    },
                                ],
                            },
                        ],
                    }}
                    texts={{
                        loading: intl.formatMessage({ id: 'global.loading' }),
                        noData: intl.formatMessage({ id: 'global.noData' }),
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                />
            </div>
        </div>
    )
}
